import { render, staticRenderFns } from "./CustomerService.vue?vue&type=template&id=fcc161ba&scoped=true&"
import script from "./CustomerService.vue?vue&type=script&lang=js&"
export * from "./CustomerService.vue?vue&type=script&lang=js&"
import style0 from "./CustomerService.vue?vue&type=style&index=0&id=fcc161ba&lang=css&scoped=true&"
import style1 from "./CustomerService.vue?vue&type=style&index=1&id=fcc161ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc161ba",
  null
  
)

export default component.exports